import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Input, InputProps } from '../../UI';
import { PersonFormValues } from '../types';
import { FC } from 'react';

type PersonOccupationInputProps = Pick<InputProps, 'label' | 'className'> &
  InputProps['inputProps'];

export const PersonOccupationInput: FC<PersonOccupationInputProps> = ({
  label,
  required,
  className,
  ...inputProps
}) => {
  const { t: tForm } = useTranslation('form');
  const {
    register,
    formState: { errors },
  } = useFormContext<PersonFormValues>();

  return (
    <Input
      className={className}
      {...register('occupation')}
      label={label ?? tForm('person-occupation-input-label')}
      status={errors.occupation ? 'errored' : 'normal'}
      inputProps={{
        placeholder: required ? tForm('general-required-placeholder') : '',
        ...inputProps,
      }}
    />
  );
};
